import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import './ActiveList.css?v=1.0';
import { ServiceVocList } from "../Services/Service";
import Table from './DataTable/DataTable';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { CustomLoader } from "../Services/CommonLibrary"
import {formatUkNumber} from "./Utils";

const queryParams = new URLSearchParams(window.location.search);
const status = queryParams.get('status');

function VocList() {

    
    const [loading, setLoading] = useState(true);
    
    const [serviceData, setServiceData] = useState([]);
    const [averageData, setAverageData] = useState([]);
    
    useEffect(() => {
        fetchVocList();
    }, []);

    const fetchVocList = async () => {
        setLoading(true);
        ServiceVocList()
            .then((res) => {
                if(res.data.status==1){
                    setServiceData(res.data.data);
                    setAverageData(res.data.average_data);
                }else{
                    setServiceData('');
                    setAverageData('');
                }
                
                setLoading(false);
            });
    }

    
    
   const emptyValue = '';
    const columns = [
        {id:1,name: "#",cell: (row, index) => index + 1,sortable: false,grow: 0},
        {id:2,name : <div className='tdData text-start'>Patient Name</div>,  selector:row=>row.userName, cell: row => <div className='tdData'>{row.userName}</div>,sortable: true},
        {id:3,name : <div className='tdData text-start'>Coach Name</div>,selector: row => row.coachName, cell: row => <div className='tdData'>{row.coachName}</div>,sortable: true},
        {id:4,name : <div className='tdData text-start'>Coach Feedback Text</div>,selector: row => row.coachFeedbackText, cell: row => <div className='tdData'>{row.coachFeedbackText}</div>,sortable: true,draw:8},
        {id:5,name : <div className='tdData text-start'>Coach Rating</div>,selector: row => row.coachFeedbackRating, cell: row => <div className='tdData'>{row.coachFeedbackRating}</div>,sortable: true},
        {id:6,name : <div className='tdData text-start'>Date Time</div>,selector: row => row.createdTime, cell: row => <div className='tdData'>{row.createdTime}</div>,sortable: true}

      ];    

    
    return (
        <section className='projects-section'>
             <div className='row'>
                <div className="FL">
                    <div className='table-responsive mt-2'>
                        <MDBTable align='middle'>
                            <MDBTableHead>
                                <tr className="table-head">
                                    <th scope='col'>Coach Name</th>
                                    <th scope='col'>Avg. Rating</th>
                                    <th scope='col'>Number of Rating</th>
                                </tr>
                            </MDBTableHead>
                            { averageData.length > 0 
                                ? 
                                <MDBTableBody>
                                    {averageData.map((data, i) => (
                                        <tr key={i}>
                                            <td>{data.coachName}</td>
                                            <td>{data.avgr}</td>
                                            <td>{formatUkNumber(data.totalnorating)}</td>
                                        </tr>
                                    ))}

                                </MDBTableBody> 
                                :
                                <MDBTableBody>
                                    <tr>
                                        <td colSpan={5}>No Records Found</td>
                                    </tr>
                                </MDBTableBody>}
                        </MDBTable>
                        <hr className='line' />
                    </div>
                
                    <div className='table-responsive' id='coachrating'>
                        <Table data={serviceData} column={columns} title="Coach Rating" />
                    </div>
                    
                </div>
            </div>
            { loading ? <CustomLoader /> : null }

        </section>
        

    );
}
export default VocList;